<div class="app-header">
  <div class="header-trigger" (click)="layoutService.onCollapsedChange()">
    <i
      class="trigger"
      nz-icon
      [nzType]="isCollapsed() ? 'menu-unfold' : 'menu-fold'"
    ></i>
  </div>
  <button
    nz-button
    (click)="logout()"
  >
    <i nz-icon nzType="logout" class="icon-logout"></i>
    Выход
  </button>
  <div class="login">
    <i nz-icon nzType="user"></i>
    {{ login }}
  </div>
</div>